const DocumentListView = () => import("../presentation/views/DocumentListView.vue");
const DocumentEditorView = () => import("../presentation/views/DocumentEditorView.vue");
export const documentRoutes = [
    {
        path: "/documents",
        name: "DocumentList",
        component: DocumentListView,
        meta: { requiresAuth: true, titleKey: "document.title" },
    },
    {
        path: "/documents/:id/edit",
        name: "DocumentEditor",
        component: DocumentEditorView,
        meta: { requiresAuth: true, hideHeader: true, titleKey: "document.title" },
        props: true,
    },
    {
        // Same editor view, letter endpoints behind it: the `source` prop switches
        // which API the store reads and hides the template-only publish surface.
        path: "/courriers/:id/edit",
        name: "LetterEditor",
        component: DocumentEditorView,
        meta: { requiresAuth: true, hideHeader: true, titleKey: "document.letters.title" },
        props: (route) => ({ id: route.params.id, source: "letter" }),
    },
];
export const documentNavigationItems = [
    {
        labelKey: "document.title",
        icon: "ri-file-text-line",
        path: "/documents",
        meta: { requiresAuth: true },
    },
];
